// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketingFeedUnit_container__1RWYn","date":"MarketingFeedUnit_date__1Teah","title":"MarketingFeedUnit_title__rvumh","address":"MarketingFeedUnit_address__3YTI3"};